import { combineReducers } from 'redux';

import users from './users/reducer';
import groups from './groups/reducer';
import traders from './traders/reducer';
import ccyInfo from './currencyPairs/reducer';

const reducers = combineReducers({
  users,
  groups,
  traders,
  ccyInfo
});
export default reducers;



// WEBPACK FOOTER //
// ./src/admin/reducers.js